import ApiTeams from '@/api/apiTeams'
import ApiPlayers from '@/api/apiPlayers'
import Vue from 'vue'
import router from '../router'
import Team from '@/models/team'
import Player from '@/models/player'
import { createActionHelpers } from 'vuex-loading'

const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading'
})

const state = {
  teams: [],
  team: new Team(),
  player: null,
  showPlayerDialog: false,
  players:[]
}

const actions = {
  loadTeams(context) {
    startLoading(context.dispatch, 'loading teams')
    ApiTeams.all((teams) => {
      context.commit("updateTeams", teams)
      endLoading(context.dispatch, 'loading teams')
    }, error => {
      console.log('Error', error)
      endLoading(context.dispatch, 'loading teams')
    })
  },
  loadTeam(context, teamID){
    if (teamID){
      startLoading(context.dispatch, 'loading team')
      ApiTeams.find(teamID, team => {
        console.log(team)
        context.commit("updateTeam", team)
        endLoading(context.dispatch, 'loading team')
      }, error => {
        endLoading(context.dispatch, 'loading team')
      })
    }

  },
  createTeam(context, team){
    startLoading(context.dispatch, 'creating team')
    ApiTeams.create(team, response => {
      endLoading(context.dispatch, 'creating team')
      context.commit("updateTeam", new Team())
      context.dispatch('goTeams')
    }, error => {
      console.log('Error', error)
      endLoading(context.dispatch, 'loading team')
    })
  },
  updateTeam(context,team){
    startLoading(context.dispatch, 'updating team')
    ApiTeams.update(team, response => {
      endLoading(context.dispatch, 'updating team')
      context.commit("updateTeam", new Team())
      context.dispatch('goTeams')
    }, error => {
      endLoading(context.dispatch, 'updating team')
      console.log('Error', error)
    })
  },
  removeTeam(context, team){
    startLoading(context.dispatch, 'removing team')
    ApiTeams.delete(team, response => {
      context.dispatch('loadTeams')
      endLoading(context.dispatch, 'removing team')
    }, error => {
      endLoading(context.dispatch, 'removing team')
      console.log('Error', error)
    })
  },
  associateTeam(context, data) {
    startLoading(context.dispatch, 'associating team')
    ApiTeams.associateTeam(data.teamID, data.tournamentID, (response) => {
      endLoading(context.dispatch, 'associating team')
      context.dispatch('loadTournamentTeams', data.tournamentID)
      context.dispatch('loadTeams')

      console.log(response)
    }, (error) => {
      endLoading(context.dispatch, 'associating team')
      console.log('Error', error)
    })
  },
  unlinkTeam(context,data){
    startLoading(context.dispatch, 'unlink team')
    ApiTeams.unlinkTeam(data.teamId, response => {
      endLoading(context.dispatch, 'unlink team')
      context.dispatch('loadTournamentTeams', data.tournamentId)
    }, error => {
      console.log('Error', error)
      endLoading(context.dispatch, 'unlink team')
    })
  },
  removeTeamFromTournament(context, data) {
    startLoading(context.dispatch, 'removing team from tournament')
    ApiTeams.removeTeamFromTournament(data, response => {
      endLoading(context.dispatch, 'removing team from tournament')
      context.dispatch('loadTournamentTeams', data.tournamentID)
    }, error => {
      endLoading(context.dispatch, 'removing team from tournament')
      console.log('Error', error)
    })
  },
  showNewPlayerDialog(context,data){
    context.commit('updatePlayer', new Player())
    context.commit('updateShowPlayerDialog', true)
  },
  showEditPlayerDialog(context,data){
    context.commit('updatePlayer', data)
    context.commit('updateShowPlayerDialog', true)
  },
  cancelPlayerDialog(context){
    context.commit('updateShowPlayerDialog', false)
  },
  saveNewPlayer(context,player){
    console.log("PLAYER",player)
    startLoading(context.dispatch, 'creating player')
    ApiPlayers.create(player, response => {
      endLoading(context.dispatch, 'creating player')
      context.commit('updateShowPlayerDialog', false)
      context.dispatch("loadPlayersPerTeam",player.teamId)
    }, error => {
      console.log('Error', error)
      endLoading(context.dispatch, 'creating player')
    })
  },
  updatePlayer(context,player){
    console.log("PLAYER",player)
    startLoading(context.dispatch, 'update player')
    ApiPlayers.update(player.id,player, response => {
      endLoading(context.dispatch, 'update player')
      context.commit('updateShowPlayerDialog', false)
      context.dispatch("loadPlayersPerTeam",player.teamId)
    }, error => {
      console.log('Error', error)
      endLoading(context.dispatch, 'update player')
    })
  },
  loadPlayersPerTeam(context,teamId){
    startLoading(context.dispatch, 'loading')
    ApiPlayers.allInTeam(teamId, response => {
      endLoading(context.dispatch, 'loading')
      /*ESTO SE TIENE QUE QUITAR CUANDO EXISTA API*/
      var players = []
      for(var i in response){
        if(response[i].teamId==teamId){
          players.push(response[i])
        }
      }
      /**/
      context.commit("updatePlayersPerTeam", players)
    }, error =>{
      console.log('Error', error)
      endLoading(context.dispatch, 'loading')
    })
  },
  removePlayer(context, player){
    startLoading(context.dispatch, 'removing player')
    ApiPlayers.delete(player,(response)=>{
      context.dispatch('loadFields')
      endLoading(context.dispatch, 'removing player')
      context.dispatch("loadPlayersPerTeam",player.teamId)
    }, error => {
      endLoading(context.dispatch, 'removing player')
      console.log(error)
    })
  },
  sendTeamLink(context,data){
    startLoading(context.dispatch, 'sending-team-link')
    ApiTeams.sendTeamLink(data.teamid,data.email, response => {
      endLoading(context.dispatch, 'sending-team-link')
    }, error => {
      endLoading(context.dispatch, 'sending-team-link')
      console.log('Error', error)
    })
  }
}

const mutations = {
  updateTeams(state, teams){
    state.players = []
    state.team = new Team()
    state.teams = teams
  },
  updateTeam(state, team){
    state.team = team
  },
  updatePlayer(state,player){
    state.player = player
  },
  updateShowPlayerDialog(state,show){
    state.showPlayerDialog = show
  },
  updatePlayersPerTeam(state,players){
    state.players = players
  }
}

const getters = {
  currentTeams(state) {
    return state.teams
  },
  currentTeam(state) {
    return state.team
  },
  currentShowPlayerDialog(state){
    return state.showPlayerDialog
  },
  currentPlayer(state){
    return state.player
  },
  currentPlayersPerTeam(state){
    return state.players
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/teams.js